module.exports = __webpack_public_path__ + "static/img/brees-2004-top.ffc24eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-top.jpg
// module id = Vj0O
// module chunks = 1